import React, { ComponentProps, forwardRef, Ref } from "react";
import {
  ButtonTagContentsWrapper,
  StyledButtonTag,
} from "./__styles__/ButtonTag";
import { Icon, IconNames } from "./Icons/LucideIcons";
import { Body } from "./Typography";

export type ButtonProps = Omit<
  ComponentProps<typeof StyledButtonTag>,
  "css"
> & {
  iconName?: IconNames;
};

const ButtonTag = forwardRef(
  ({ iconName, ...props }: ButtonProps, ref: Ref<HTMLButtonElement>) => {
    const disabled = props.disabled ?? false;

    const iconColor = disabled ? "contentSecondary" : "contentPrimary";

    return (
      <StyledButtonTag {...props} ref={ref} tabIndex={0}>
        <ButtonTagContentsWrapper>
          {iconName && <Icon iconName={iconName} color={iconColor} size={16} />}
          <Body size="default" type="emphasis" color="inherit" as="span">
            {props.children}
          </Body>
        </ButtonTagContentsWrapper>
      </StyledButtonTag>
    );
  },
);

// including this so we can view the component name instead of forwardRef
// in our tooling (React DevTools, etc)
ButtonTag.displayName = "ButtonTag";

export { ButtonTag };
